import { render } from "./CrSwitcher.vue?vue&type=template&id=520cd776&scoped=true"
import script from "./CrSwitcher.vue?vue&type=script&lang=js"
export * from "./CrSwitcher.vue?vue&type=script&lang=js"

import "./CrSwitcher.vue?vue&type=style&index=0&id=520cd776&scoped=true&lang=scss"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520cd776"]])

export default __exports__